import { render, staticRenderFns } from "./PanelInputSwitch.vue?vue&type=template&id=275c5a10&scoped=true&"
import script from "./PanelInputSwitch.vue?vue&type=script&lang=js&"
export * from "./PanelInputSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PanelInputSwitch.vue?vue&type=style&index=0&id=275c5a10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275c5a10",
  null
  
)

export default component.exports